import { Deserializable } from '../_common/deserializable';

export class DnRevenue implements Deserializable{
    shortCode: string;
    keyword: string;
    operator: string;
    client: string;
    share: string;
    price: string;
    dnSuccess: number;
    amount: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
